import React from 'react';
import {
  SlideListProps,
  SlideList as SdkSlideList,
} from '@display-component/pc';

import 'swiper/css';

const SlideList = <T extends {}>(props: SlideListProps<T>) => (
  <SdkSlideList {...props} />
);

export default SlideList;
